import * as React from 'react';
import { HomeLandingContainer, HomeLandingText } from './HomeLanding.style';
import { MarginContainer } from '../../lib/shared';

const HomeLanding = ({ landingText }) => {
  return (
    <HomeLandingContainer>
      <MarginContainer>
        <HomeLandingText>{landingText}</HomeLandingText>
      </MarginContainer>
    </HomeLandingContainer>
  );
};

export default HomeLanding;
